<template>
	<span v-if="data || $slots.default" v-show="data.name || $slots.default" class="c-state" :tag="tag" :style="compStyle">
		<i v-if="tag && data.icon" class="tf">{{data.icon}}</i>
		<span v-if="$slots.default"><slot></slot></span>
		<span v-else>{{data.name}}</span>
	</span>
</template>

<script>
	import {mapState} from 'vuex'
	
	export default {
		name: 'cState',
		
		props: {
			dict: String,
			async: Boolean,
			value: [Number, String],
			color: {
				type: [Boolean, String],
				default: true
			},
			tag: Boolean,
			hollow: Boolean
		},
		
		data() {
			return {
				colorDict: {
					gray: '#999999',
					blue: '#0D6EFE',
					red: '#FF0000',
					green: '#2EBC78',
					yellow: '#FFAE00',
					orange: '#FF5400'
				}
			}
		},
		
		computed: {
			...mapState(['dictData', 'asyncDictData']),
			
			compDictData() {
				if (this.async) {
					return this.asyncDictData[this.dict];
				} else {
					return this.dictData[this.dict];
				}
			},
			
			data() {
				return this.compDictData ? this.compDictData[this.value] : {name: this.value};
			},

			compStyle() {
				let color = typeof this.color == 'string' ? this.color : this.colorDict[this.data.color] || this.data.color;
				return this.tag ? {
					'border-color': color,
					color: this.hollow ? color : '#fff',
					background: this.hollow ? '#fff' : color
				} : {
					color: this.color ? color : ''
				}
			}
		},
		
		created() {
			if (this.async && this.dict && !this.compDictData) {
				this.$store.dispatch('getAsyncDict', this.dict);
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.c-state {
		&[tag] {
			border-width: 1px;
			border-style: solid;
			padding: 2px 4px;
			border-radius: 4px;
			line-height: normal;

			.tf {
				margin-right: 2px;
			}
		}	
	}
</style>